var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18.9583H7.50004C6.40004 18.9583 5.48337 18.85 4.70837 18.6166C4.42504 18.5333 4.24171 18.2583 4.25837 17.9666C4.46671 15.475 6.99171 13.5166 10 13.5166C13.0084 13.5166 15.525 15.4666 15.7417 17.9666C15.7667 18.2666 15.5834 18.5333 15.2917 18.6166C14.5167 18.85 13.6 18.9583 12.5 18.9583ZM5.60004 17.55C6.15004 17.6583 6.77504 17.7083 7.50004 17.7083H12.5C13.225 17.7083 13.85 17.6583 14.4 17.55C13.9584 15.95 12.1334 14.7666 10 14.7666C7.86671 14.7666 6.04171 15.95 5.60004 17.55Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 1.66699H7.49984C3.33317 1.66699 1.6665 3.33366 1.6665 7.50033V12.5003C1.6665 15.6503 2.6165 17.3753 4.88317 18.017C5.0665 15.8503 7.2915 14.142 9.99984 14.142C12.7082 14.142 14.9332 15.8503 15.1165 18.017C17.3832 17.3753 18.3332 15.6503 18.3332 12.5003V7.50033C18.3332 3.33366 16.6665 1.66699 12.4998 1.66699ZM9.99984 11.8086C8.34984 11.8086 7.0165 10.467 7.0165 8.81701C7.0165 7.16701 8.34984 5.83366 9.99984 5.83366C11.6498 5.83366 12.9832 7.16701 12.9832 8.81701C12.9832 10.467 11.6498 11.8086 9.99984 11.8086Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99994 12.433C8.00827 12.433 6.3916 10.808 6.3916 8.81636C6.3916 6.82469 8.00827 5.20801 9.99994 5.20801C11.9916 5.20801 13.6083 6.82469 13.6083 8.81636C13.6083 10.808 11.9916 12.433 9.99994 12.433ZM9.99994 6.45801C8.69994 6.45801 7.6416 7.51636 7.6416 8.81636C7.6416 10.1247 8.69994 11.183 9.99994 11.183C11.2999 11.183 12.3583 10.1247 12.3583 8.81636C12.3583 7.51636 11.2999 6.45801 9.99994 6.45801Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/upload-image.a5db97065cdf483a59d5003bf2e9153c.svg";
export { ForwardRef as ReactComponent };